module.exports = __webpack_public_path__ + "static/media/maestro-4.87b134a7.png";